import * as React from 'react';

import { ECurrentLocations } from '../../../../../../shared/utils/demand';
import { Filter } from '../../../components/advancedFilters/common/Filter';
import { InlineFilter } from '../../../components/advancedFilters/common/InlineFilter';
import { InlineFilterGroup } from '../../../components/advancedFilters/common/InlineFilterGroup';
import { RadioButtonGroup } from '../../../components/RadioButtonGroup';
import { useContext } from '../../../utils/useContext';

export const WithNeighborsContainer: React.FC = () => {
  const { onChange, jsonQuery, currentLocation } = useContext();
  const withNeighbors = React.useMemo(() => {
    const { value } = jsonQuery.with_neighbors || {};
    if (value === undefined) {
      return true;
    }

    return value;
  }, [jsonQuery.with_neighbors]);

  const options = React.useMemo(() => {
    let locationName;
    if (currentLocation === 'moscow_mo') {
      locationName = ECurrentLocations.moscowAndMO;
    } else if (currentLocation === 'spb_lo') {
      locationName = ECurrentLocations.spbAndLO;
    } else {
      locationName = currentLocation.displayName;
    }

    return [
      {
        label: locationName,
        value: false,
      },
      { label: `${locationName} + 20км`, value: true },
    ];
  }, [currentLocation]);

  const handleChange = React.useCallback(
    (withNeighbors: boolean) => {
      onChange({ action: 'setWithNeighbors', arguments: [withNeighbors ? null : false] });
    },
    [onChange],
  );

  return (
    <Filter id="advancedFilter_withNeighbors" label="Радиус поиска">
      <InlineFilterGroup>
        <InlineFilter>
          <RadioButtonGroup spliced={false} options={options} value={withNeighbors} onChange={handleChange} />
        </InlineFilter>
      </InlineFilterGroup>
    </Filter>
  );
};
